import { addSpotsAction } from "fleet/redux-store/ui-state/strategy-v2";
import { AddWebPageForm } from "fleet/view/media-library/add-web-page-form";
import { connect } from "react-redux";

function mapDispatchToProps(dispatch) {
  return {
    addSpots: (payload) => {
      dispatch(addSpotsAction(payload));
    },
  };
}

const ConnectedAddWebPageForm = connect(
  null,
  mapDispatchToProps,
)(AddWebPageForm);

export { ConnectedAddWebPageForm };
